/**
 * PSU Data Adapter
 *
 * Loads PSU detail data and merges with pricing data from separate files.
 * Uses the generic adapter pattern for consistency.
 */

import type { PSUModel } from '../../models/psu/psu-model'
import { createSingletonAdapter, type GenericDataAdapter } from '../common/GenericDataAdapter'

// Create singleton instance using generic adapter
const { getAdapter, resetAdapter } = createSingletonAdapter<PSUModel>({
  basePath: '/data/psu',
  componentName: 'psu'
})

/**
 * Get the singleton instance of PSUDataAdapter
 */
export function getPSUDataAdapter(): GenericDataAdapter<PSUModel> {
  return getAdapter()
}

/**
 * Reset the singleton instance (useful for testing)
 */
export function resetPSUDataAdapter(): void {
  resetAdapter()
}

// Re-export for backward compatibility
export type PSUDataAdapter = GenericDataAdapter<PSUModel>
